module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/tmb_gallery8-6b7bc1891bffc3d540c79388f94a19eb.jpg";